import { getTypography, ThemedFunctor, TypographyName } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ $disabled, $interactive, $operation }) => css`
  ${($interactive || $disabled) && `
    user-select: none;
  `}

  ${$disabled && `
    opacity: .5;
  `};

  .statusIcon {
    display: flex;
  }

  .operationIcon {
    display: none;
  }

  ${$operation && !$disabled && `
    &:hover {
      .statusIcon {
        display: none;
      }

      .operationIcon {
        display: flex;
      }
    }
  `}
`;

export const icon: ThemedFunctor = ({ theme, $active }) => css`
  background: ${theme.color.background[$active ? 'primary' : 'neutral'].default.low};
  border-radius: ${theme.remRounding.M};
  width: ${theme.remSize[300]};
  height: ${theme.remSize[300]};
  color: ${theme.color.foreground[$active ? 'primary' : 'neutral'].default.low};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const index: ThemedFunctor = ({ theme, $active }) => css`
  ${getTypography(theme, TypographyName.HEADING_4)}
  color: ${theme.color.foreground[$active ? 'primary' : 'neutral'].default.low};
`;

export const text: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY_SMALL)}
`;
